module.exports = __webpack_public_path__ + "static/media/Mohan babu University.4cc9990a.gif";